export const PieChartHelper = () => {

    const CalculatePieChartData = (variables,total) => {
        let pieChartData = [];
        variables.forEach(variable => {
            if (variable.value === 0) return;
            let percentage = ((variable.value / total) * 100).toFixed(2);
            pieChartData.push({
                name: variable.name,
                value: parseFloat(percentage),
                fill: variable.fill
            })
        });
        return pieChartData;
    }

    return {
        CalculatePieChartData
    }
}

export default PieChartHelper;
